import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../@fury/shared/material-components.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  declarations: [LoginComponent]
})
export class LoginModule {
  message: string
  logged_in: string
  userid: string
  userrole: string
  unofficialwainstance: string
  unofficialwabranch: string
  accesscontrolip: number
  max_sales_discount_percent: string
  salescommission: string
  allow_login: string
  username: string
  userphoto: string
  userjob: string
  email: string
  first_name: string
  locations: Array<string>
  layout: number
  autoattend: number
  createcustomer: string
  editcustomer: string
  viewcustomer: string
  listcustomer: string
  role: string
  settings: string
  developer: string
  listplans: string
  editplans: string
  createplans: string
  viewplans: string
  listtickets: string
  createticket: string
  viewticket: string
  editticket: string
  closeticket: string
  listothertickets: string
  assignticket: string
  canreplyclosedtickets: string
  createbranch: string
  viewassignedpotential: string
  viewallpotential: string
  assignpotential: string
  editpotential: string
  createpotential: string
  createfollowup: string
  viewtransaction: string
  edittransaction: string
  listtransactions: string
  createxpense: string
  viewexpense: string
  editexpense: string
  listexpenses: string
  listemployees: string
  createblog: string
  listblog: string
  editblog: string
  editplanbenefitsfromprofile: string
  listsubscriptions: string
  addsubscriptionfromprofile: string
  subscriptionmodificationsfromprofile: string
  viewticketfromprofile: string
  freezefromprofile: string
  invitefromprofile: string
  useservicefromprofile: string
  addpaymentfromprofile: string
  editstartdatefromprofile: string
  viewfollowsfromprofile: string
  addfollowupfromprofile: string
  innertransferfromprofile: string
  editcoachfromprofile: string
  outertransferfromprofile: string
  editsubscriptionbenefits: string
  upgradesubfromprofile: string
  downgradesubfromprofile: string
  refundsubfromprofile: string
  cancelsubfromprofile: string
  canblockcustomerfromprofile: string
  cansearchblockedcustomer: string
  listattendancedaily: string
  listinvitationsdaily: string
  unfreezesubfromprofile: string
  listsubscriptionsdue: string
  editsubscriptionpricefromprofile: string
  salescomissionreport: string
  coachcomissionreport: string
  incomereport: string
  birthdatereport: string
  addattachmentfromprofile: string
  listbranches: string
  editsubscriptiondiscoundfromprofile: string
  salesfollowscountreport: string
  followstypecountreport: string
  salesabouttoexpirereport: string
  listoutertransfer: string
  rejectoutertransfer: string
  editoutertransfermoney: string
  approveoutertransfer: string
  transfercustomerfromemptoemp: string
  globalcustomersearch: string
  blockedclientsreport: string
  listdailyfinancialreport: string
  listscheduledfollowsreport: string
  listexpensereport: string
  editsubsalesfromprofile: string
  listinvitationsreport: string
  listpotential: string
  listbyagentticketsreport: string
  listbyinquiryticketsreport: string
  listbyagentticketsperiodreport: string
  listbyinquiryticketsperiodreport: string
  viewcallsfromcustomerprofile: string
  createnews: string
  editnews: string
  listnews: string
  deletenews: string
  viewnews: string
  createcompanies: string
  editcompanies: string
  listcompanies: string
  deletcompanies: string
  viewcompanies: string
  listdiscounds: string
  creatediscound: string
  editdiscound: string
  deletediscound: string
  viewdiscound: string
  listfaqs: string
  createfaqs: string
  viewfaqs: string
  editfaqs: string
  deletefaqs: string
  listsubscriptionsdueinstallment: string
  editsubscriptioninvoicebenefits: string
  deletecustomernotefromprofile: string
  searchcustomerbyname: string
  cansuspendsubfromprofile: string
  canunsuspendsubfromprofile: string
  caneditduedate: string
  canviewattendancereport: string
  notactivereport: string
  listsalaries: string
  addsalary: string
  editsalary: string
  showattendancefromprofile: string
  addemployeevacation: string
  approvesalary: string
  blockedemployeereport: string
  salariesreport: string
  changeslogcustomerfromprofile: string
  changeslogsubscriptionfromprofile: string
  changeslogcustomerreport: string
  changeslogsubscriptionreport: string
  customercreationreport: string
  addsession: string
  canapprovesubscription: string
  canfreezeanytime: string
  canclosedrawer: string
  drawerreport: string
  drawertransactionsreport: string
  canceltransaction: string
  employeeattendance: string
  canapplyattendance: string
  cansearchforemployee: string
  transactioncreationperiodreport: string
  followupanalyticsreport: string
  isLoggedIn(): boolean {
    // Check if the user has an authentication token in local storage
    return localStorage.getItem('logged_in') == '1';
  }
  setdata(model: any){
    this.message = model.message;
    this.logged_in = model.logged_in;
    localStorage.setItem('logged_in', this.logged_in);
    this.userid = model.userid;
    localStorage.setItem('userid', this.userid);
    this.userrole = model.userrole;
    localStorage.setItem('userrole', this.userrole);
    // this.unofficialwainstance = model.unofficialwainstance;
    // this.unofficialwabranch = model.unofficialwabranch;
    // this.accesscontrolip = model.accesscontrolip;
    // this.max_sales_discount_percent = model.max_sales_discount_percent;
    // this.salescommission = model.salescommission;
    // this.allow_login = model.allow_login;
    this.username = model.username;
    localStorage.setItem('username', this.username);
    this.userphoto = model.userphoto;
    localStorage.setItem('userphoto', this.userphoto);
    this.userjob = model.userjob;
    localStorage.setItem('userjob', this.userjob);
    this.email = model.email;
    localStorage.setItem('email', this.email);
    this.first_name = model.first_name;
    localStorage.setItem('first_name', this.first_name);
    this.locations = model.locations;
    // this.layout = model.layout;
    // this.autoattend = model.autoattend;
    // this.createcustomer = model.createcustomer;
    // this.editcustomer = model.editcustomer;
    // this.viewcustomer = model.viewcustomer;
    // this.listcustomer = model.listcustomer;
    this.role = model.role;
    localStorage.setItem('role', this.role);
    // this.settings = model.settings;
    // this.developer = model.developer;
    // this.listplans = model.listplans;
    // this.editplans = model.editplans;
    // this.createplans = model.createplans;
    // this.viewplans = model.viewplans;
    // this.listtickets = model.listtickets;
    // this.createticket = model.createticket;
    // this.viewticket = model.viewticket;
    // this.editticket = model.editticket;
    // this.closeticket = model.closeticket;
    // this.listothertickets = model.listothertickets;
    // this.assignticket = model.assignticket;
    // this.canreplyclosedtickets = model.canreplyclosedtickets;
    // this.createbranch = model.createbranch;
    // this.viewassignedpotential = model.viewassignedpotential;
    // this.viewallpotential = model.viewallpotential;
    // this.assignpotential = model.assignpotential;
    // this.editpotential = model.editpotential;
    // this.createpotential = model.createpotential;
    // this.createfollowup = model.createfollowup;
    // this.viewtransaction = model.viewtransaction;
    // this.edittransaction = model.edittransaction;
    // this.listtransactions = model.listtransactions;
    // this.createxpense = model.createxpense;
    // this.viewexpense = model.viewexpense;
    // this.editexpense = model.editexpense;
    // this.listexpenses = model.listexpenses;
    // this.listemployees = model.listemployees;
    // this.createblog = model.createblog;
    // this.editblog = model.editblog;
    // this.listblog = model.listblog;
    // this.editblog = model.editblog;
    this.editplanbenefitsfromprofile = model.editplanbenefitsfromprofile;
    // this.listsubscriptions = model.listsubscriptions;
    this.addsubscriptionfromprofile = model.addsubscriptionfromprofile;
    this.subscriptionmodificationsfromprofile = model.subscriptionmodificationsfromprofile;
    this.viewticketfromprofile = model.viewticketfromprofile;
    this.freezefromprofile = model.freezefromprofile;
    this.invitefromprofile = model.invitefromprofile;
    this.useservicefromprofile = model.useservicefromprofile;
    this.addpaymentfromprofile = model.addpaymentfromprofile;
    this.editstartdatefromprofile = model.editstartdatefromprofile;
    this.viewfollowsfromprofile = model.viewfollowsfromprofile;
    this.addfollowupfromprofile = model.addfollowupfromprofile;
    this.innertransferfromprofile = model.innertransferfromprofile;
    this.editcoachfromprofile = model.editcoachfromprofile;
    this.outertransferfromprofile = model.outertransferfromprofile;
    this.editsubscriptionbenefits = model.editsubscriptionbenefits;
    this.upgradesubfromprofile = model.upgradesubfromprofile;
    this.downgradesubfromprofile = model.downgradesubfromprofile;
    this.refundsubfromprofile = model.refundsubfromprofile;
    this.cancelsubfromprofile = model.cancelsubfromprofile;
    this.canblockcustomerfromprofile = model.canblockcustomerfromprofile;
    this.cansearchblockedcustomer = model.cansearchblockedcustomer;
    // this.listattendancedaily = model.listattendancedaily;
    // this.listinvitationsdaily = model.listinvitationsdaily;
    // this.unfreezesubfromprofile = model.unfreezesubfromprofile;
    // this.listsubscriptionsdue = model.listsubscriptionsdue;
    // this.editsubscriptionpricefromprofile = model.editsubscriptionpricefromprofile;
    this.salescomissionreport = model.salescomissionreport;
    this.coachcomissionreport = model.coachcomissionreport;
    // this.incomereport = model.incomereport;
    this.birthdatereport = model.birthdatereport;
    this.addattachmentfromprofile = model.addattachmentfromprofile;
    // this.listbranches = model.listbranches;
    // this.editsubscriptiondiscoundfromprofile = model.editsubscriptiondiscoundfromprofile;
    // this.salesfollowscountreport = model.salesfollowscountreport;
    // this.followstypecountreport = model.followstypecountreport;
    this.salesabouttoexpirereport = model.salesabouttoexpirereport;
    // this.listoutertransfer = model.listoutertransfer;
    this.rejectoutertransfer = model.rejectoutertransfer;
    this.editoutertransfermoney = model.editoutertransfermoney;
    this.approveoutertransfer = model.approveoutertransfer;
    this.transfercustomerfromemptoemp = model.transfercustomerfromemptoemp;
    this.globalcustomersearch = model.globalcustomersearch;
    this.blockedclientsreport = model.blockedclientsreport;
    // this.listdailyfinancialreport = model.listdailyfinancialreport;
    // this.listscheduledfollowsreport = model.listscheduledfollowsreport;
    // this.listexpensereport = model.listexpensereport;
    this.editsubsalesfromprofile = model.editsubsalesfromprofile;
    this.listinvitationsreport = model.listinvitationsreport;
    this.listpotential = model.listpotential;
    // this.listbyagentticketsreport = model.listbyagentticketsreport;
    // this.listbyinquiryticketsreport = model.listbyinquiryticketsreport;
    // this.listbyagentticketsperiodreport = model.listbyagentticketsperiodreport;
    // this.listbyinquiryticketsperiodreport = model.listbyinquiryticketsperiodreport;
    this.viewcallsfromcustomerprofile = model.viewcallsfromcustomerprofile;
    // this.createnews = model.createnews;
    // this.editnews = model.editnews;
    // this.listnews = model.listnews;
    // this.deletenews = model.deletenews;
    // this.viewnews = model.viewnews;
    // this.createcompanies = model.createcompanies;
    // this.editcompanies = model.editcompanies;
    // this.listcompanies = model.listcompanies;
    // this.deletcompanies = model.deletcompanies;
    // this.viewcompanies = model.viewcompanies;
    // this.listdiscounds = model.listdiscounds;
    // this.creatediscound = model.creatediscound;
    // this.editdiscound = model.editdiscound;
    // this.deletediscound = model.deletediscound;
    // this.viewdiscound = model.viewdiscound;
    // this.listfaqs = model.listfaqs;
    // this.createfaqs = model.createfaqs;
    // this.viewfaqs = model.viewfaqs;
    // this.editfaqs = model.editfaqs;
    // this.deletefaqs = model.deletefaqs;
    this.listsubscriptionsdueinstallment = model.listsubscriptionsdueinstallment;
    this.editsubscriptioninvoicebenefits = model.editsubscriptioninvoicebenefits;
    this.deletecustomernotefromprofile = model.deletecustomernotefromprofile;
    this.searchcustomerbyname = model.searchcustomerbyname;
    this.cansuspendsubfromprofile = model.cansuspendsubfromprofile;
    this.canunsuspendsubfromprofile = model.canunsuspendsubfromprofile;
    this.caneditduedate = model.caneditduedate;
    this.canviewattendancereport = model.canviewattendancereport;
    this.notactivereport = model.notactivereport;
    // this.listsalaries = model.listsalaries;
    // this.addsalary = model.addsalary;
    // this.editsalary = model.editsalary;
    // this.showattendancefromprofile = model.showattendancefromprofile;
    // this.addemployeevacation = model.addemployeevacation;
    // this.approvesalary = model.approvesalary;
    // this.blockedemployeereport = model.blockedemployeereport;
    // this.salariesreport = model.salariesreport;
    // this.changeslogcustomerfromprofile = model.changeslogcustomerfromprofile;
    // this.changeslogsubscriptionfromprofile = model.changeslogsubscriptionfromprofile;
    // this.changeslogcustomerreport = model.changeslogcustomerreport;
    // this.changeslogsubscriptionreport = model.changeslogsubscriptionreport;
    this.customercreationreport = model.customercreationreport;
    this.addsession = model.addsession;
    this.canapprovesubscription = model.canapprovesubscription;
    this.canfreezeanytime = model.canfreezeanytime;
    this.canclosedrawer = model.canclosedrawer;
    // this.drawerreport = model.drawerreport;
    // this.drawertransactionsreport = model.drawertransactionsreport;
    // this.canceltransaction = model.canceltransaction;
    // this.employeeattendance = model.employeeattendance;
    // this.canapplyattendance = model.canapplyattendance;
    // this.cansearchforemployee = model.cansearchforemployee;
    this.transactioncreationperiodreport = model.transactioncreationperiodreport;
    // this.followupanalyticsreport = model.followupanalyticsreport;
  }
}
